import { render, staticRenderFns } from "./simRecoveryRecord.vue?vue&type=template&id=ad73bc2c&scoped=true&"
import script from "./simRecoveryRecord.vue?vue&type=script&lang=js&"
export * from "./simRecoveryRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad73bc2c",
  null
  
)

export default component.exports